<div class="mail-confirm-body flex-col flex-justify-center flex-align-center">
    <h2 class="mail-confirm-text">{{ title() }}</h2>
    <p class="lato-text">{{ mailConfirmationText() }}</p>
    @if (!showEmailEdit()) {
    <div class="flex-col flex-justify-center flex-align-center button-container">
        <div class="flex-row flex-justify-center flex-align-center button-row">
            <button (click)="onResendClick()" mat-raised-button color="accent" class="mail-confirm-button"
                [disabled]="resendCooldown() > 0">
                @if (resendCooldown() > 0) {
                {{ 'dottnet.emailConfirm.button.resendCooldown' | translate:{ seconds: resendCooldown() } }}
                } @else {
                {{ 'dottnet.emailConfirm.button.resend' | translate }}
                }
            </button>
            @if (!isLocking()) {
            <button (click)="dismissEvent.emit()" mat-raised-button color="accent" class="mail-confirm-button">
                {{ 'dottnet.emailConfirm.button.notNow' | translate }}
            </button>
            }
        </div>
        @if (!isLinkExpired()) {
        <div class="flex-row flex-justify-center flex-align-center">
            <button (click)="onUpdateEmailClick()" mat-raised-button color="primary" class="mail-confirm-button">
                {{ 'dottnet.emailConfirm.button.updateEmail' | translate }}
            </button>
        </div>
        }
    </div>
    } @else {
    <div class="flex-col flex-justify-center flex-align-center button-container">
        <dottnet-email-update
            [currentEmail]="user()?.email ?? ''"
            [showCancel]="true"
            (saved)="onEmailSaved($event)"
            (cancelled)="onCancelEdit()">
        </dottnet-email-update>
    </div>
    }
</div>